import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useUserProfile } from '../../configuration/login/loginSlice';
import { accessToken } from '../../configuration/tokenHandling/accessToken';
import { fetchJwt, mapLocaleToFeatureBaseLocale } from './FeatureBaseWrapper';

const FeatureBaseSurveyWrapper = () => {
    const intl = useIntl();
    const userProfile = useUserProfile();

    const accessTokenResolver = async () => accessToken.getAccessToken();

    useEffect(() => {
        const setup = async () => {
            const token = await accessTokenResolver();
            const theme = document.cookie.includes('uikit-color-scheme=dark') ? 'dark' : 'light';
            const featureBaseJwt = await fetchJwt(token, userProfile, intl.locale);
            window.Featurebase('initialize_survey_widget', {
                organization: 'rio',
                placement: 'bottom-left',
                theme,
                locale: mapLocaleToFeatureBaseLocale(intl.locale),
                jwtToken: featureBaseJwt,
            });
        };

        if (typeof window.Featurebase === 'function') {
            setup().catch(console.error);
        } else {
            console.warn('Featurebase is not yet loaded');
        }
    }, []);

    return null;
};

export default FeatureBaseSurveyWrapper;
